import keys from 'constants/keys'
import { SubtaskDeepDiveItem, TasksInsights, TransformedDataWithCounts } from 'redux/actions/tasks_v2'
import { CHART_COLORS, getInsightsSubtaskTitle } from 'utils/taskAnalytics'

type GetSubtasksByTypeArgs = {
  insights: TransformedDataWithCounts
  allInsights: TasksInsights
  tid: string
  subtaskTypes: number[]
}
export const getSubtasksByType = ({ insights, allInsights, tid, subtaskTypes }: GetSubtasksByTypeArgs) => {
  return Object.keys(insights).reduce<{
    contextIds: string[]
    subtasks: SubtaskDeepDiveItem[]
  }>(
    (acc, key) => {
      const insight = insights[key]

      const hasMatchingSubtask = insight.items.some((item) => subtaskTypes.includes(item.type))

      if (hasMatchingSubtask) {
        acc.contextIds.push(key)

        const matchingSubtasks = insight.items.filter((item) => subtaskTypes.includes(item.type))

        matchingSubtasks.forEach((subtask) => {
          if (!acc.subtasks.some((existing) => existing.st_id === subtask.st_id)) {
            const subtaskWithTitle = {
              ...subtask,
              title: getInsightsSubtaskTitle(allInsights[tid].sub_tasks[subtask.st_id], subtask.title),
            }
            acc.subtasks.push(subtaskWithTitle)
          }
        })
      }

      return acc
    },
    { contextIds: [], subtasks: [] }
  )
}
export const getStatusConfigColor = (statusValue: number, showIcon = true) => {
  switch (statusValue) {
    case keys.TASK_STATUSES.DONE.value:
    case keys.TASK_STATUSES.SKIPPED.value:
      return { color: CHART_COLORS.done, showIcon: showIcon }
    case keys.TASK_STATUSES.INPROGRESS.value:
      return { color: CHART_COLORS.inProgress, showIcon: showIcon }
    case keys.TASK_STATUSES.TODO.value:
      return { color: CHART_COLORS.todo, showIcon: showIcon }
    case keys.TASK_STATUSES.APPROVED.value:
      return { color: CHART_COLORS.approved, showIcon: showIcon }
    case keys.TASK_STATUSES.DISAPPROVED.value:
      return { color: CHART_COLORS.rejected, showIcon: showIcon }
    case keys.TASK_STATUSES.REVIEWED_BY_AI.value:
      return { color: CHART_COLORS.reviewedByAi, showIcon: showIcon }
    default:
      return { color: CHART_COLORS.todo, showIcon: showIcon }
  }
}
